export default function SubcontextoContextoManagerService(
  $q,
  $rootScope,
  userAccessContext,
  entidadeContextoHolderService,
  acessoContextoHolderService,
  sistemaContextoHolderService,
  appContextoService
) {

  const DEFAULT_CONTEXT_VALUE = '0';

  const getApplicationContext = () => {
    return 'SubcontextoContextoHolderService';
  };

  const resolve = (subcontextoHash) => {
    if (!subcontextoHash || _.isEmpty(subcontextoHash)) {
      return $q.when(null);
    }

    const subcontexto = JSON.parse(atob(subcontextoHash));
    const subcontextoId = Object.keys(subcontexto)[0];
    const subcontextoValue = Object.values(subcontexto)[0];

    const acessos = acessoContextoHolderService.get();
    const sistema = sistemaContextoHolderService.get();
    const contextoAtual = entidadeContextoHolderService.getObject();

    const acessoSistema = _.find(acessos, acesso =>
      acessoMatchesCurrentContext(acesso, sistema, contextoAtual, subcontextoId, subcontextoValue)
    );

    $rootScope.$emit('gerenciador.acessos.subcontexto.selecionado', {
      subcontexto: {
        id: subcontextoId,
        value: subcontextoValue
      }
    });

    if (subcontextoValue === DEFAULT_CONTEXT_VALUE) {
      appContextoService.clearAppContext();
    } else {
      appContextoService.setAppContext(acessoSistema);
    }
    userAccessContext.setUserAccess(acessoSistema);

    return $q.resolve(subcontexto);
  };

  const acessoMatchesCurrentContext = (acesso, sistema, contextoAtual, subcontextoId, subcontextoValue) => {
    return isSameSystemAndEntity(acesso, sistema, contextoAtual)
      && isSameSubcontext(acesso, subcontextoId, subcontextoValue);
  };

  const isSameSystemAndEntity = (acesso, sistema, contextoAtual) => {
    return acesso.system == sistema && acesso.values.entity == contextoAtual.values.entity;
  };

  const isSameSubcontext = (acesso, subcontextoId, subcontextoValue) => {
    return acesso.values[subcontextoId] === subcontextoValue
      || isDefaultContext(subcontextoValue, acesso, subcontextoId);
  };

  const isDefaultContext = (subcontextoValue, acesso, subcontextoId) => {
    return subcontextoValue === DEFAULT_CONTEXT_VALUE && acesso.values[subcontextoId] === undefined;
  };

  return {
    getApplicationContext,
    resolve,
  };
}

SubcontextoContextoManagerService.$inject = [
  '$q',
  '$rootScope',
  'UserAccessContext',
  'EntidadeContextoHolderService',
  'AcessoContextoHolderService',
  'SistemaContextoHolderService',
  'AppContextService',
];
